import React from 'react';
import { Box } from '../../base/Box/Box';
import { Type } from '../../base/Type/Type';
import { CompanyIntroSectionStoryblok } from '../../types/storyblok';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';
import Marquee from 'react-fast-marquee';

export const CompanyIntroSection = ({
  subheading,
  heading,
  stats,
  logos,
  colourScheme = 'white',
  overlayOverBkg,
}: CompanyIntroSectionStoryblok) => {
  if (!subheading && !heading && !stats && !logos) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      bkg
      blockSpacing
      overlayOverBkg={overlayOverBkg}
    >
      <Box as="div" className="mx-auto max-w-standard">
        <Type as="h3" typography="subheading">
          {subheading}
        </Type>
        <Type as="h2" className="mb-9 max-w-xl text-p1">
          {heading}
        </Type>

        <Box
          as="ul"
          className="align-center mt-7 inline-flex flex-wrap gap-6 rounded-[0.25em] px-[0.75em] py-[0.5em]"
          highlightBkg
          overlayOverBkg
        >
          {renderStoryblokComponents({ blocks: stats })}
        </Box>
      </Box>
      {logos && (
        <Box as="div" className="mx-auto mt-15 flex gap-30 lg:mt-30">
          <Marquee>{renderStoryblokComponents({ blocks: logos })}</Marquee>
        </Box>
      )}
    </Box>
  );
};

export default CompanyIntroSection;
